<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-02-04 10:12:43
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-08-25 10:17:17
 * @FilePath: \sns-user-frontend\src\components\web\commentEditor.vue
 * @Description: 
-->
<template>
  <div class="comment-editor">
    <!-- 评论框引用内容显示 -->
    <div class="quote" v-if="quote">
      <section v-html="quote"></section>
      <Avatar 
        :avatarInfo="props.authorInfo"
        :size="24"
        :iconSize="9"
        :canRoute="false"
      >
        <span>{{ props.authorInfo.nickname }}</span>
      </Avatar>
    </div>

    <!-- 自定义插入内容 -->
    <slot name="beforeAction"></slot>
    <div class="tiny-container">
      <!-- 自定义placeholder -->
      <div class="tiny-placeholder" @click="focusTiny" v-show="showPlaceholder">
        <slot>{{$t('addComment')}} </slot>
      </div>
      <!-- 输入框 -->
      <Editor
        :id="`${editorType}-editor`"
        style="opacity:0"
        v-model="content"
        :init="initOptions"
        @focus="setFocus"
        @blur="setFocus"
      />
      <div class="emoji-overlay" v-if="isOverly"></div>
    </div>
    <!-- 自定义提交按钮 -->
    <div class="custom-submit-btn" @click="onSubmit" v-if="showCustomBtn">
      <slot name='afterAction'></slot>
    </div>

    <!-- 引用按钮 -->
    <ObQuote :editorType="editorType" @sendQuoteHtml="getQuoteHtml"></ObQuote>
  </div>

  <template v-if="attachments.length">
    <div
      v-if="attachments[0].status === 'progress'"
      class="layer"
    >
      <van-circle
        v-model:current-rate="attachments[0].progress"
        :rate="attachments[0].progress"
        :speed="100"
        :text="`${isNaN(attachments[0].progress) ? '' : `${attachments[0].progress}%`}`"
        size="70px"
        stroke-width="80"
        color="var(--theme)"
      />
    </div>
    <div
      v-else
      class="layer delete-layer"
    >
      <svg-icon name="icon-live" v-if="attachments[0]?.oliveInfo"></svg-icon>
      <el-image fit="cover" :src="attachments[0]?.previewUrl || attachments[0]?.url"/>
      <svg-icon @click="deleteImage()" name="icon-delete-round"/>
    </div>
  </template>

  <div class="action">
    <div>
      <div
        v-for="tool in customToolBar"
        :key="tool.name"
        class="action-icon"
      >
       <el-popover class="emoji-popover" :placement="offsetAmount ? 'left' : 'bottom-start'" trigger="click"  v-if="tool.name === 'icon-emoji'" @show="showEmojiOverly" @hide="hideEmojiOverly">
          <template #reference>
            <svg-icon :name="tool.name"/>
          </template>
          <EmojiBox :gaCommentMess="props.threadInfo" :commentData="props.commentData"/>
        </el-popover>
        <svg-icon 
          v-if="tool.name === 'icon-image' && !attachments.length"
          :name="tool.name"
          :class="tool.name"
          @click="() => {tool.trigger(tool.dialogClass, `.${tool.name}`)}"
        />
        <svg-icon 
          v-if="tool.name !== 'icon-image' && tool.name !== 'icon-emoji'"
          :name="tool.name"
          :class="tool.name"
          @click="() => {tool.trigger(tool.dialogClass, `.${tool.name}`)}"
        />

      </div>
    </div>

    <div>
      <span class="limit" :class="wordCount > cloudConfig.commentContentLimit && 'over-limit'" v-show="showWordLimit && needLimit">{{ wordCount }}/{{ cloudConfig.commentContentLimit }}</span>
      <ObButton
        v-show="!showCustomBtn"
        :text="$t('comment')"
        class="comment"
        :disabled="disabled"
        :loading="loading"
        :callBack="onSubmit">
      </ObButton>
    </div>
  </div>


  <van-uploader
    v-model="attachments"
    ref="uploadImageRef"
    accept="image/*"
    class="upload-button"
    :max-count="1"
    :after-read="onChangeImage"
  />


  <div class="dialog-wrap">
    <Dialog 
      v-model:visible="linkVisible"
      :customClass="`link-dialog-com-${editorType}`"
      :showModal="false"
      @onClose="onClose"
    >
      <div class="custom-dialog">
        <p>{{ $t('link')}} </p>
        <el-input 
          ref="linkRef"
          v-model="linkInfo.link"    
        />
        <p>{{ $t('text') }}</p>
        <el-input 
          v-model="linkInfo.text"    
        />
      </div>
      <template #footer>
        <div class="footer">
          <el-button @click="onClose">{{ $t('cancel') }}</el-button>
          <el-button :disabled="!linkInfo.link" @click="insertLink">{{ $t('ok') }}</el-button>
        </div>
      </template>
    </Dialog>
    <Dialog 
      v-model:visible="mentionVisible"
      :customClass="`mention-dialog-com-${editorType}`"
      :showModal="false"
      :showFoot="false"
      @onClose="onClose"
    >
      <div class="custom-dialog mention">
        <el-input 
          ref="mentionRef"
          v-model="keyword"    
          :placeholder="$t('searchUserNameValidate')"
        />
        <UserList 
          :keyword="keyword"
          @insertMentionGuy="insertMentionGuy"
        />
      </div>
    </Dialog>
    <Dialog 
      v-model:visible="quickMentionVisible"
      customClass="quick-mention-dialog-com"
      :showModal="false"
      :showFoot="false"
      @onClose="onClose"
    >
      <div class="custom-dialog quick-mention">
        <UserList 
          :keyword="keyword"
          @insertMentionGuy="(e) => {insertMentionGuy(e, true)}"
        />
      </div>
    </Dialog>
  </div>
</template>

<script setup>
//引入tinymce编辑器
import Editor from '@tinymce/tinymce-vue';
// 引入富文本编辑器主题的js和css
//引入方式引入node_modules里的tinymce相关文件文件
import tinymce from 'tinymce/tinymce'; //tinymce默认hidden，不引入则不显示编辑器
import 'tinymce/models/dom'
import 'tinymce/themes/silver'; //编辑器主题，不引入则报错
// tinymce样式
import 'tinymce/icons/default'; //引入编辑器图标icon，不引入则不显示对应图标
// 引入编辑器插件
import 'tinymce/plugins/advlist'; //高级列表
import 'tinymce/plugins/autolink'; //自动链接
import 'tinymce/plugins/autoresize'; //编辑器高度自适应,注：plugins里引入此插件时，Init里设置的height将失效
// import 'tinymce/plugins/fullpage'; //文档属性
import 'tinymce/plugins/fullscreen'; //全屏
import 'tinymce/plugins/link'; //超链接
import 'tinymce/plugins/lists'; //列表插件
import 'tinymce/plugins/wordcount'; //字数统计

import Avatar from '@/components/avatar'
import Dialog from '@/components/web/dialog'
import UserList from '@/views/post/web/components/userList'
import EmojiBox from '@/components/web/emojiBox'

import http from '@/service'
import UploadFile from '@/hooks/upload'
import XssFilter from '@/utils/xssFilter'

import { storeToRefs } from 'pinia';
import { position } from 'caret-pos'
import { useSystemStore } from '@/stores/system'
import { richText4View, richText4Upload } from '@/utils/formatRichText'

const route = useRoute()
const systemStore = useSystemStore()
const { cloudConfig } = storeToRefs(systemStore)
const { proxy } = getCurrentInstance()

const props = defineProps({
  authorInfo: {
    type: Object,
  },
  tid: {
    type: String,
  },
  commentData: {
    type: Object
  },
  editorType: {
    type: String,
    default: 'comment'
  },
  threadInfo: {
    type: Object,
    default: () => {}
  },
  // 是否显示字数限制
  needLimit:{
    type:Boolean,
    default: true
  },
  // 是否需要自定义提交按钮
  showCustomBtn:{
    type:Boolean,
    default: false
  },
  // 输入框背景色
  tinyTheme:{
    type:String,
    default:''
  },
  // 特殊情况 action弹框被挡住添加偏移量
  offsetAmount:{
    type: Number,
    default: 0
  },
  // 评论成功后提示
  customToast:{
    type:String,
    default:''
  }
})

const emit = defineEmits(['create', 'update'])
const showWordLimit = ref(false)
const keyword = ref('')
const content = ref('')
const wordCount = ref(0)
const loading = ref(false)
const typingChinese = ref(false)
const quickMentionVisible = ref(false)
const commentData = ref(null)
const isFocus = ref(false)

const showPlaceholder = computed(() => {
  return !isFocus.value && !content.value && !commentData.value?.fromUserBasicInfo
})

const disabled = computed(() => {
  let imgList = content.value.match(/<img [^>]*>/gi) || []
  const imgUploadStatus = attachments.value.length ? attachments.value[0].status !== 'complete' : !attachments.value.length
  return !wordCount.value && imgUploadStatus && imgList.length === 0
})

// tinymec背景色
const theameStyleArr = {
  dark: 'body{background:#2e2e2e;color:#fff;}', // 直播
  white: 'body{background:rgba(255, 255, 255, 0.60);}' // 周边
}

const initOptions = ref({
  selector: `#${props.editorType}-editor`,
  resize: false, //编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
  menubar: false, //菜单栏
  branding: false,  //tiny技术支持信息是否显示
  statusbar: false,  //最下方的元素路径和字数统计那一栏是否显示
  elementpath: false, //元素路径是否显示
  custom_colors: false, // 禁止自定义色板
  text_patterns: false, // 禁止语义转换，比如#回车
  object_resizing: false,
  paste_webkit_styles: 'all', // 保留内联样式
  language: import.meta.env.VITE_COUNTRY === 'CHINA' ? 'zh-Hans' : 'en_US', //语言类型
  language_url: '/tinymce/langs/zh-Hans.js',
  skin_url: '/tinymce/skins/ui/oxide', //皮肤：浅色
  icons_url: '/tinymce/icons/default/icons.js',
  plugins: 'autoresize wordcount', //插件配置
  newline_behavior:'linebreak', // 换行p标签换成br标签
  min_height: 55, // 自适应高度最小高度
  max_height: props.editorType === 'comment' ? 500 : 170, // 自适应高度最大高度
  autoresize_bottom_margin: 0, // 自适应高度底部边距
  autoresize_overflow_padding: 16, // 自适应高度左右边距
  toolbar: false, //工具栏配置，设为false则隐藏
  noneditable_class: 'mceNonEditable',
  font_family_formats: 'orbit-R',
  placeholder: '',
  content_css: '/commentContent.css?version=4', //以css文件方式自定义可编辑区域的css样式，css文件需自己创建并引入
  content_style: props.tinyTheme ? theameStyleArr[props.tinyTheme] : '',
  mobile: {
    plugins: 'autoresize wordcount', //插件配置
    menubar: false, //菜单栏
    branding: false,  //tiny技术支持信息是否显示
    statusbar: false,  //最下方的元素路径和字数统计那一栏是否显示
    elementpath: false, //元素路径是否显示
    custom_colors: false, // 禁止自定义色板
    text_patterns: false, // 禁止语义转换，比如#回车
    object_resizing: false,
    paste_webkit_styles: 'all', // 保留内联样式
    min_height: 55, // 自适应高度最小高度
    max_height: props.editorType === 'comment' ? 500 : 170, // 自适应高度最大高度
    autoresize_bottom_margin: 0, // 自适应高度底部边距
    autoresize_overflow_padding: 16, // 自适应高度左右边距
    newline_behavior:'linebreak', // 换行p标签换成br标签
    language: import.meta.env.VITE_COUNTRY === 'CHINA' ? 'zh-Hans' : 'en_US', //语言类型
    language_url: '/tinymce/langs/zh-Hans.js',
    // skin_url: '/tinymce/skins/ui/oxide', //皮肤：浅色
    icons_url: '/tinymce/icons/default/icons.js',
    toolbar: false, //工具栏配置，设为false则隐藏
    noneditable_class: 'mceNonEditable',
    font_family_formats: 'orbit-R',
    placeholder: proxy.$t('addComment'),
    content_css: '/commentContent.css?version=3', //以css文件方式自定义可编辑区域的css样式，css文件需自己创建并引入
  },
  setup: (editor) => {
    // 处理有序/无序列表标识颜色
    editor.on('change', (e) => {
      
    })
    editor.on('focus', (e) => {
      showWordLimit.value = true
    })
    editor.on('blur', (e) => {
      showWordLimit.value = false
    })
    editor.on('click', (e) => {
      const cordinate = tinymce.activeEditor.selection.getRng().startContainer.parentElement
      const mentionTag = tinymce.activeEditor.contentDocument.querySelector('a[data-mention]')
      if (cordinate.nodeName !== 'A' && mentionTag) {
        mentionTag.remove()
        quickMentionVisible.value = false
        setTimeout(() => {
          tinymce.activeEditor.execCommand('mceInsertContent', false, '')
        }, 300)
      }
    })
    editor.on('compositionstart', () => {
      typingChinese.value = true
    })
    editor.on('compositionend', () => {
      typingChinese.value = false
    })
    editor.on('keyup', (e) => {
      if (!typingChinese.value) {
        const cordinate = tinymce.activeEditor.selection.getRng().startContainer.parentElement
        // @人搜索
        const mentionTag = tinymce.activeEditor.contentDocument.querySelector('a[data-mention]')
        if (mentionTag) {
          if (e.key === 'Escape' || e.key === 'Enter') {
            e.preventDefault()
            mentionTag.remove()
            tinymce.activeEditor.execCommand('mceInsertContent', false, mentionTag.innerText)
            quickMentionVisible.value = false
          } else {
            let mentionGuy = mentionTag.innerText
            if (mentionGuy[0] === '@') {
              mentionGuy = mentionGuy.substr(1, mentionGuy.length)
              quickMentionVisible.value = !!mentionGuy
              setTimeout(() => {
                keyword.value = mentionGuy
                if (quickMentionVisible.value) {
                  const frame = document.querySelector(`#${props.editorType}-editor_ifr`)
                  // 编辑器dom ,has contenteditable atrribute
                  const body = tinymce.activeEditor.contentWindow.document.body
                  let { top, height } = position(body, { iframe: frame })
                  const { top: cordinateTop, left: cordinateLeft} = frame.getBoundingClientRect()
                  top += (cordinateTop + height + 20)
                  let left = cordinateLeft + tinymce.activeEditor.contentDocument.querySelector('a[data-mention]').offsetLeft
                  const { clientHeight } = document.documentElement
                  let borderRadius = '0 0 8px 8px'
                  if (clientHeight - top <= 270) {
                    borderRadius = '8px 8px 0 0'
                    top -= (206 + height)
                  }
                  nextTick(() => {
                    document.querySelector('.quick-mention-dialog-com').parentElement.style.position = 'unset'
                    document.querySelector('.quick-mention-dialog-com').parentElement.parentElement.style.position = 'unset'
                    document.querySelector('.quick-mention-dialog-com').setAttribute('style', `position:fixed;top:${`${top}px`};left:${`${left}px`};border-radius:${borderRadius};`)
                    setTimeout(() => {
                      tinymce.activeEditor.execCommand('mceInsertContent', false, '')
                    }, 300)
                  })
                }
              }, 200)
            }
          }
          // setTimeout(() => {
          //   tinymce.activeEditor.execCommand('mceInsertContent', false, '')
          // }, 300)
        } else {
          if (quickMentionVisible.value) {
            quickMentionVisible.value = false
            setTimeout(() => {
              tinymce.activeEditor.execCommand('mceInsertContent', false, '')
            }, 300)
          }
        }
      }
    })
    editor.on('keydown', (e) => {
      if (e.key === '@') {
        e.preventDefault()
        tinymce.activeEditor.execCommand('mceInsertContent', false, '<a data-type="@" data-mention>@</a>')
        return
      }
      if (!tinymce.activeEditor.plugins.wordcount.body.getCharacterCount() && e.key === 'Backspace') {
        quote.value = ''
      }
    })
  },
  init_instance_callback: () => {
    // 添加社区标识，用于设置主题色
    tinymce.activeEditor.contentDocument.body.className += document.body.className
    setTimeout(() => {
      let content = tinymce.activeEditor?.getContent({ format: "text" });
      wordCount.value = content?.replace(/[\r\n]/g,"").length
    }, 100)
  },
  // 移除原有粘贴内容
  paste_preprocess: (plugin, args) => {
    const pastContent = XssFilter(args.content, {
      "div": ["style", "class"],
      "span": ["style", "class"],
      "strong": ["style", "class"],
      "p": ["style", "class"],
      "i": ["style", "class"],
      "u": ["style", "class"],
      "em": ["style", "class"],
      "br": ["style", "class"],
      "ul": ["style", "class"],
      "ol": ["style", "class"],
      "li": ["style", "class"],
      "a": ["style", "class", "href"],
      "b": ["class", "style"]
    }, {
      whiteList: {
        'font-size': false,
        'font-style': false,
        'font-weight': false,
        'text-align': false,
        'list-style': false,
      }
    })
    args.content = ''
    tinymce.activeEditor.execCommand('mceInsertContent', false, pastContent)
  }
});


const focusTiny = () => {
  const eidtorName = `${props.editorType}-editor`
  if (tinymce.get(eidtorName)) {
    tinymce.get(eidtorName).focus()
    tinymce.get(eidtorName).selection.select(tinymce.get(eidtorName).getBody(), true)
    tinymce.get(eidtorName).selection.collapse(false)
  }
}

// 引用内容
const quote = ref('');

const getQuoteHtml=(val)=>{
  quote.value =  val
}

const removeMentionVisible = (e) => {
  if (quickMentionVisible.value) {
    const mentionTag = tinymce.activeEditor.contentDocument.querySelector('a[data-mention]')
    mentionTag.remove()
    tinymce.activeEditor.execCommand('mceInsertContent', false, mentionTag.innerText)
    quickMentionVisible.value = false
  }
}


const attachments = ref([])
const uploadImageRef = ref(null)
const linkVisible = ref(false)
const mentionVisible = ref(false)
const linkInfo = ref({})
const linkRef = ref(null)
const mentionRef = ref(null)

const insertLink = () => {
  const { link, text } = linkInfo.value
  if (!link.match(/[a-zA-z]+:\/\/[^\s]*/) || /\s/.test(link)) {
    proxy.$toast({
      message: proxy.$t('linkValidate')
    })
    return
  }
  const tag = `<a href="${link}" data-type="link" data-value="${link}">${text || link}</a> `
  tinymce.activeEditor.execCommand('mceInsertContent', false, tag)
  linkVisible.value = false
}

const insertMentionGuy = ({uid, nickname}, deleteQuickMentionTag) => {
  if (deleteQuickMentionTag) {
    tinymce.activeEditor.contentDocument.querySelector('a[data-mention]').remove()
  }
  const link = `${location.origin}/user/${uid}`
  const tag = `<a href="${link}" data-type="@" data-value="${uid}">@${nickname}</a> `
  tinymce.activeEditor.execCommand('mceInsertContent', false, tag)
  mentionVisible.value = false
  quickMentionVisible.value = false
}

const setDialogPosition = (dialogClass, targetTag) => {
  const targetList = document.querySelectorAll(targetTag)
  const { top, left, width, height } = targetList[targetList.length - 1].getBoundingClientRect()
  const { clientHeight } = document.documentElement
  setTimeout(() => {
    let offsetHeight = 0
    const dialogList = document.querySelector(dialogClass)
    const dialogHeight = document.querySelector(dialogClass).offsetHeight
    if (top + dialogHeight >= clientHeight) {
      offsetHeight = top - dialogHeight
    } else {
      offsetHeight = top + height + 10
    }
    document.querySelector(dialogClass).setAttribute('style', `position:fixed;top:${`${offsetHeight}px`};left:${`${left - props.offsetAmount}px`};`)
  }, 100)
}

const onShowLinkDialog = (dialogClass, targetTag) => {
  linkVisible.value = true
  setDialogPosition(dialogClass, targetTag)
  // 回显选中
  let selectRng = tinymce.activeEditor.selection.getRng().startContainer.parentElement
  if (selectRng.nodeName === 'A') {
    linkInfo.value.text = selectRng.innerText
    linkInfo.value.link = selectRng.dataset.value
  } else {
    let vituralDom = document.createElement('div')
    vituralDom.innerHTML = tinymce.activeEditor.selection.getContent().replaceAll('&nbsp;', '') || ''
    linkInfo.value.text = vituralDom.innerText
  }
  setTimeout(() => {
    linkRef.value.focus()
  }, 500)
}

const onShowMentionDialog = (dialogClass, targetTag) => {
  mentionVisible.value = true
  setDialogPosition(dialogClass, targetTag)
  // 回显选中
  setTimeout(() => {
    mentionRef.value.focus()
  }, 500)
}
const onChangeImage = async (file) => {
  file.type = 1
  file.progress = 0
  file.status = 'uploading'
  file = [file]
  await UploadFile(file, 'thread', '', true)
}

const deleteImage = () => {
  attachments.value = []
}

// emoji弹框
const isOverly = ref(false)
const showEmojiOverly = ()=>{
  isOverly.value = true
  let gaParams = {
    "screen_name": route.name,
    "thread_category": props.threadInfo?.type,
    "thread_id": route.params.id,
    "circle_id": props.threadInfo?.circleBasicInfo?.id,
    "circle_name": props.threadInfo?.circleBasicInfo?.name,
  }
  if (props.commentData) {
    gaParams.post_id = props.commentData?.parentCid || props.commentData?.id
  }
  proxy.$ga(props.commentData ? ( commentData.value.isEdit ? 'post_edit_add_emoji' : 'post_reply_add_emoji') : 'thread_reply_add_emoji', gaParams)
}

const hideEmojiOverly = ()=>{
  isOverly.value = false
}

const onClose = () => {
  linkInfo.value = { link: '', text: '' }
  linkVisible.value = false
  mentionVisible.value = false
}

const customToolBar = ref([{
  name: 'icon-image',
  class: '.icon-image',
  trigger: () => {
    uploadImageRef.value.chooseFile()
  },
  hide: attachments.value.length
},
{
  name: 'icon-emoji',
  class: '.icon-emoji',
  dialogClass: '',
  trigger: ''
},{
  name: 'icon-at',
  class: '.icon-at',
  dialogClass: `.mention-dialog-com-${props.editorType}`,
  trigger: onShowMentionDialog
}, {
  name: 'icon-chain',
  class: '.icon-chain',
  dialogClass: `.link-dialog-com-${props.editorType}`,
  trigger: onShowLinkDialog
}])


const onSubmit = async () => {
  if (disabled.value) return
  let topic = ''
  if (props.threadInfo && props.threadInfo.topicInfo) {
    JSON.parse(props.threadInfo.topicInfo).forEach((item, index) => {
      topic += item.name + (JSON.parse(props.threadInfo?.topicInfo).length - 1  === index ? '' : ' + ')
    })
  }
  let gaParams = {
    "screen_name": route.name,
    "thread_category": props.threadInfo?.type,
    "thread_id": route.params.id,
    "circle_id": props.threadInfo?.circleBasicInfo?.id,
    "circle_name": props.threadInfo?.circleBasicInfo?.name,
    "topic": topic
  }
  if (props.commentData) {
    gaParams.post_id = props.commentData?.parentCid || props.commentData?.id
  }
  proxy.$ga(props.commentData ? 'post_reply_send' : 'thread_reply_send', gaParams)
  loading.value = true
  let uploadContent = content.value
  const params = {
    tid: props.tid,
    toUid: commentData.value?.fromUserBasicInfo?.uid || props.authorInfo.id,
    source: 'PC',
  }
  const { content: quoteContent, attachments: quoteImages } = richText4Upload(quote.value, {
    formatType: 'quote'
  })
  Object.assign(params, {
    quote: quoteContent,
    quoteImages
  })
  if (attachments.value.length) {
    params.attachments = attachments.value.map(i => i.id)
    attachments.value.forEach(i => {
      uploadContent = `${content.value}<p class="media-preview"><img data-type="${i.type === 4 ? 'sticker_self' : 'file'}" data-value="${i.id}" style="display: block;" /></p>`
    })
  }
  params.content = richText4Upload(uploadContent)?.content
  if (commentData.value) {
    if (commentData.value.isEdit) {
      params.id = commentData.value.id
    } else {
      const { parentCid, replyCid, id } = commentData.value
      params.parentCid = parentCid ? parentCid : id
      if (parentCid) {
        params.replyCid = id
      }
    }
  }
  let type = (commentData.value && commentData.value.isEdit) ? 'update' : 'create'
  const { code, data, msg } = await http.comment(params, type)
  if (code === 200) {
    emit(type, params)
    proxy.$ga(props.commentData ? 'post_reply_success' : 'thread_reply_success', gaParams)
    content.value = ''
    attachments.value = []
    quote.value = ''
  }
  if (code !== 401) {
    proxy.$toast({
      message: code === 200 && props.customToast ? props.customToast: msg
    })
  }
  loading.value = false
}

function setFocus ({type}) {
  isFocus.value = type === 'focus'
}

watch(() => content.value, (val) => {
  if(!val){
    wordCount.value = 0;
    if (props.commentData?.fromUserBasicInfo?.nickname) {
      setTimeout(() => {
        tinymce.get(`${props.editorType}-editor`).contentDocument.body.dataset.mcePlaceholder = val.isEdit ? '' : `${proxy.$t('replyTo')}${commentData.value?.fromUserBasicInfo?.nickname}`
        tinymce.get(`${props.editorType}-editor`).contentDocument.body.focus()
      }, 300);
    }
    return
  } else {
    tinymce.get(`${props.editorType}-editor`).contentDocument.body.dataset.mcePlaceholder = ''
  }
  let content = tinymce.activeEditor?.getContent({ format: "text" });
  wordCount.value = content?.replace(/[\r\n]/g,"").length
})

watch(() => props.commentData, (val) => {
  if (val) {
    commentData.value = {...val}
    if (val.isEdit) {
      if (commentData.value.content.includes('data-at')) {
        const dom = document.createElement('div')
        dom.innerHTML = commentData.value.content
        dom.querySelector('a[data-at]').remove()
        commentData.value.content = dom.innerHTML
      }
      quote.value = val.quote
      const { attachments: quoteImages } = richText4Upload(quote.value, {
        formatType: 'quote'
      })
      
      content.value = richText4View(commentData.value, {
        viewType: 'comment',
        imgMaxWidth: 195
      })
      // 去除附件中的引用图片
      attachments.value = val.attachments.reduce((prev, next) => {
        if (quoteImages.includes(next.id)) {
          return prev
        }
        next.status = 'complete'
        prev.push(next)
        return prev
      }, [])
    }
    if (val.fromUserBasicInfo?.nickname) {
      setTimeout(() => {
        tinymce.get(`${props.editorType}-editor`).contentDocument.body.dataset.mcePlaceholder = val.isEdit ? '' : `${proxy.$t('replyTo')}${commentData.value?.fromUserBasicInfo?.nickname}`
        tinymce.get(`${props.editorType}-editor`).contentDocument.body.focus()
      }, 300);
    }
  }
}, {
  immediate: true,
  deep: true
})

onMounted(() => {
  document.body.addEventListener('click', removeMentionVisible)
})

onUnmounted(() => {
  document.body.removeEventListener('click', removeMentionVisible)
})
</script>

<style lang="postcss" scoped>
.comment-editor {
  display: flex;
  flex-flow: column wrap;
  border-radius: 8px;
  background-color: #F9F9F9;
  .quote {
    display:flex;
    flex-flow: column wrap;
    align-items: flex-end;
    justify-content: flex-satart;
    max-height: fit-content;
    padding: 16px;
    margin: 16px 16px 0;
    font-style: italic;
    font-size: 16px;
    background-color: var(--background-light);
    line-height: 22px;
    
    section {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      width: 100%;
      margin-bottom: 8px;
      :deep(img) {
        /* display: none; */
        height: 36px!important;
        width: auto;
      }
    }
    span {
      font-style: italic;
      margin: 0 1px 0 8px;
    }
  }
  :deep(.tox-tinymce) {
    max-height: 392px;
    border: none;
    border-radius: 8px;
  }
}
.upload-button {
  display: none;
}

.action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  margin: 8px 0 24px;
  &-icon {
    display: inline-block;
    cursor: pointer;
    .svg-icon {
      margin-right: 24px;
    }
  }
  .comment {
    --el-button-bg-color: transparent;
    --el-button-active-color: var(--text-primary);
    --el-color-primary-dark-2: var(--text-primary);
    --el-button-hover-bg-color: transparent;
    --el-button-disabled-bg-color: var(--text-primary);
    --el-button-bg-color: var(--theme);
    --el-button-active-color: var(--theme);
    --el-color-primary-dark-2: var(--theme);
    --el-button-hover-bg-color: var(--theme);
    --el-button-disabled-bg-color: var(--theme-disabled);
    color: #FFFFFF;
    border: none;
    height: 36px;
    padding: 0 24px;
    font-size: 14px;
    width: auto !important;
  }
  .limit{
    color: var(--text-hint);
    margin-right: 16px;
    font-size: 12px;
  }
  .over-limit {
    color: red;
  }
}
.dialog-wrap {
  :deep(.el-dialog) {
    border: 1px solid var(--line);
    border-radius: 8px;
    background-color: #FFF;
    overflow: hidden;
  }
}
.custom-dialog {
  padding: 24px 24px 0;
  background-color: #FFF;
  p {
    font-size: 14px;
    font-family: 'orbit-M';
    color: var(--text-secondary);
    margin-bottom: 8px;
  }
  .el-input {
    --el-border: none;
    --el-input-border-color: none;
    --el-input-focus-border-color: none;
    --el-input-hover-border-color: none;
    --el-component-size: 40px;
    --el-font-size-base: 16px;
    --el-input-border-radius: 100px;
    --el-input-bg-color: #F9F9F9;
    width: 336px;
    margin-bottom: 24px;
    :deep(.el-input__wrapper) {
      padding: 1px 14px;
    }
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #FFF;
  padding-bottom: 24px;
  :deep(.el-button) {
    --el-font-size-base: 16px;
    --el-button-hover-text-color: unset;
    --el-button-bg-color: transparent;
    --el-button-active-color: transparent;
    --el-button-hover-bg-color: transparent;
    --el-button-active-bg-color: transparent;
    border: none;
    padding: 12px 24px;
    margin-right: 24px;
    &:last-child {
      --el-button-text-color: var(--theme);
    }
  }
}
.mention {
  padding: 0;
  .el-input {
    width: 100%;
    min-width: 260px;
    padding: 24px 24px 12px;
    margin: 0;
  }
}
.quick-mention {
  padding: 0;
  min-width: 200px;
}

.layer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 80px;
  margin: 8px 16px 0;
}
.delete-layer {
  background-color: unset;
  .svg-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    display: none;
  }
  &:hover {
    -webkit-filter: grayscale(.2); /* Old Chrome、Old Safari、Old Opera*/
    filter: grayscale(.2); /* 现代浏览器标准 */
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=0.2);
    .svg-icon {
      display: block;
    }
  }
  .icon-live{
    display: block;
    left: 4px;
    top: 4px;
    z-index: 99;
    width: 18px;
    height: 18px;
  }
}
.el-image {
  flex-shrink: 0;
  width: fit-content;
  height: 80px;
}
:deep(.quick-mention-dialog-com) {
  z-index: 2000;
}

:deep(.emoji-dialog){
  border:none!important;
}
.tiny-container{
  position:relative;
  .emoji-overlay{
    display:block;
    width:100%;
    height:100%;
    z-index:2003;
    position: absolute;
    top: 0;
  }
  .tiny-placeholder {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.3);
    z-index: 90;
  }
}
.el-popover{
  /* z-index:100; */
  transition:none;
}
:deep(img[data-type="live_self"]){
  display: none;
}
</style>